var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBecklarLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_2",
    "data-name": "Layer 2",
    viewBox: "0 0 220.1 52.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, " .cls-1 { fill: #99d6ea; } .cls-2 { fill: #419edf; } .cls-3 { fill: #0072ce; } .cls-4 { fill: #0071ce; } "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M76.1,15.16h-9v21.7h9c3.6,0,6.5-2.9,6.5-6.5,0-1.6-.6-3.1-1.6-4.3,1-1.2,1.6-2.7,1.6-4.3,0-3.6-2.9-6.6-6.5-6.6m-.1,17.3h-4.5v-4.1h4.5c1.1,0,2.1,.9,2.1,2.1s-.9,2-2.1,2m0-8.6h-4.5v-4.1h4.5c1.1,0,2.1,.9,2.1,2.1,0,1.1-.9,2-2.1,2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M111,26.06c0,6,4.9,10.9,10.9,10.9h4.7v-4.5h-4.7c-3.5,0-6.4-2.9-6.4-6.4s2.9-6.4,6.4-6.4h4.7v-4.5h-4.7c-6,0-10.9,4.9-10.9,10.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "137.5 25.66 137.5 15.26 133 15.26 133 36.96 137.5 36.96 137.5 32.76 151.8 15.26 146 15.26 137.5 25.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "143.5 31.86 142.7 32.86 146 36.96 146.8 36.96 151.8 36.96 145.6 29.36 143.5 31.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "162.7 15.26 158.2 15.26 158.2 27.66 158.2 32.46 158.2 36.96 162.7 36.96 173.8 36.96 173.8 32.46 162.7 32.46 162.7 15.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "187.2 15.16 179.3 36.96 184.1 36.96 189.6 21.76 195.2 36.96 199.9 36.96 192 15.16 187.2 15.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M215.2,28.86c2.4-1.2,4.1-3.6,4.1-6.5,0-4-3.2-7.2-7.2-7.2h-7.6v21.7h4.5v-7.4h1.5l4.4,7.3h5.2l-4.9-7.9h0Zm-3.1-3.7h-3.2v-5.4h3.1c1.5,0,2.7,1.2,2.7,2.7,.1,1.4-1.2,2.7-2.6,2.7"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 89,
    y: 15.26,
    width: 15.5,
    height: 4.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "104.6 23.86 104.6 28.36 93.5 28.36 93.5 32.46 104.6 32.46 104.6 36.96 89 36.96 89 23.86 104.6 23.86"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35,26.06c-1.5,.9-2.7,2.3-3.1,4.1-.5,1.7-.2,3.5,.7,5.1l5.6,9.7H0c.3,4.5,3.8,7.2,7.5,7.2H50.7l-15.2-26.4-.5,.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.2,29.96c1.5,.9,3.3,1.1,5.1,.7,1.7-.5,3.2-1.6,4.1-3.1l5.6-9.7,19.1,33.2c3.7-2.5,4.3-6.9,2.5-10.1L35,3.46l-15.2,26.2,.4,.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31.2,40.66c0-1.9-.8-3.6-2.2-4.9-1.3-1.2-3-1.8-4.7-1.7H13.3L32.3,.86c-4-2-8.1-.3-9.9,2.9L.8,41.26l30.3-.1,.1-.5h0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBecklarLogo);
export default __webpack_public_path__ + "static/media/becklar_logo.e898ba62a791ad256e08fc8d141fbedf.svg";
export { ForwardRef as ReactComponent };